import { getSessionSaga, reduceLoading, reduceOperation } from 'metrix-common3';
import { call, put } from 'redux-saga/effects';
import { reduceBordereauSummaries } from '../../actions/policies/reduceBordereauSummaries';

export function* getBordereauSummariesSaga(action) {
    try {
        yield put(reduceLoading({ code: 'getBordereauSummaries', value: true }));
        const session = yield getSessionSaga();
        const productCode = action.payload;

        const response = yield call(fetch, `/api/BordereauSummary/product/${productCode}`, {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
                Accept: 'application/json',
                Authorization: session.authenticationToken.token,
                'Content-Type': 'application/json',
            },
        });

        const result = yield call([response, 'json']);

        if (result.operation) {
            yield put(reduceOperation(result.operation));
            if (!result.operation.status) return;
        }

        yield put(reduceBordereauSummaries(result.summaries || []));
    } catch (error) {
        console.log('Error while calling Get Bordereau Summaries API - ', error);
    } finally {
        yield put(reduceLoading({ code: 'getBordereauSummaries', value: false }));
    }
}
